module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d05-471d011870ff2f3a5ba7e4cc6334540b.jpg";